import EzController from 'controllers/ez-base-controller';
import events from 'lib/events';
import { resolvePath, triggerCustomEvent } from 'lib/helpers';

export default class ClickTrackController extends EzController {
  connect() { /* do nothing */ }

  track() {
    const data = this.clickFormData();
    window.navigator.sendBeacon('/api/v2/tracking/clicks', data);
  }

  trackAnalytics() {
    const resolvedEvent = resolvePath((this.element as HTMLElement).dataset.eventType, events);
    triggerCustomEvent(resolvedEvent, {});
  }

  clickFormData() {
    const formData = new FormData();
    formData.append(this.csrfParam, this.csrfToken);

    for (let i = 0; i < this.element.attributes.length; i += 1) {
      const attrib = this.element.attributes[i];
      if (attrib.name.match(/^data-/)) {
        const normalized = attrib.name.replace('data-', '').replace('-', '_');
        if (!['controller', 'action'].includes(normalized)) {
          formData.append(normalized, attrib.value);
        }
      }
    }

    return formData;
  }

  normalizeParamName(name) {
    return name.split(/(?=[A-Z])/).join('_').toLowerCase();
  }
}
